import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  flex-direction: column;
  row-gap: 8px;
`;

export const SwitchContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
`;
